
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/codebuild/output/src3693196591/src/and-dine-hub/sentry.client.config.ts")
            }
          });